export enum HeaderSearchEnum {
  CLIENTS = 'clients',
  CAMPAIGNS = 'campaigns',
  SALES_OPPORTUNITIES = 'sales-opportunities',
  OFFERS = 'offers'
}
